<template>
    <div>
      <div class="form-group">
        <div class="pull-left">
          
        </div>
        <div style="clear:both;"></div>
      </div>

      <p v-if="errorMessage !== ''" class="alert alert-danger">{{ errorMessage }}</p>

      <div class="row">
        <div class="col-12 col-md-12 col-lg-6">
          <div class="card p-3" style="background: linear-gradient(90deg, rgba(6,182,194,1) 0%, rgba(75,226,131,1) 100%); color: white;">
            <div class="form-group p-2">
              <div class="pull-left">
                <router-link :to="{path: '/'}" style="color:#ffffff;"><span class="ti-arrow-left"></span>&nbsp;<span>back</span></router-link>
              </div>
              <div class="pull-right">
                <div class="form-check-inline" title="Public ESG Data" style="line-height:1.75;vertical-align:middle;display:none;">
                  <input style="height:20px;width:20px;" :class="{'form-check-input':true, 'cursor-forbidden':!actions.canUpdateCase}" id="ispubliccase_input" type="checkbox" :disabled="!actions.canUpdateCase" @change="saveCaseIsPublic" v-model="casee.isPublic" required>
                  <label class="form-check-label" for="ispubliccase_input" style="margin-bottom:0;color:#ffffff;font-size:16px;">
                    Public<span v-if="savingCasePublic">...</span>
                  </label>
                </div>
                <button v-if="casee.companyTradeTitle" :class="{'ml-2':true, btn:true, 'btn-sm':true, 'cursor-forbidden':!actions.canDeleteCase}" @click="initDeleteCaseModal" :disabled="!actions.canDeleteCase" style="background:none;color:#ffffff;border:1px solid #ffffff;">Delete ESG Data</button>
                <button v-if="casee.companyTradeTitle && casee.status !== 'completed'" :class="{'ml-2':true, btn:true, 'btn-sm':true, 'cursor-forbidden':!actions.canUpdateCaseStatus}" @click="initCompleteCaseModal" :disabled="!actions.canUpdateCaseStatus" style="background:none;color:#ffffff;border:1px solid #ffffff;">Finalize ESG Data</button>
                <button v-if="casee.companyTradeTitle && casee.status === 'completed'" :class="{'ml-2':true, btn:true, 'btn-sm':true, 'cursor-forbidden':!actions.canUpdateCaseStatus}" @click="incompleteCase" :disabled="!actions.canUpdateCaseStatus || incompletingCase" style="background:none;color:#ffffff;border:1px solid #ffffff;">Open ESG Data<span v-if="incompletingCase">...</span></button>
              </div>
              <div style="clear:both;"></div>
            </div>
            <div class="form-group">
              <span v-if="casee.companyTradeTitle" style="font-size:25px;">
                <img v-if="casee.companyLogoPath" :src="casee.companyLogoPath" height="70">
                <span v-else>{{ casee.companyTradeTitle }}</span>
                <select v-if="companyCases.length>0" class="ml-3" v-model="selectedCaseId" @change="handleCaseYearChanged()">
                  <option v-for="(caseLiteDto, index) in companyCases" :key="index" :value="caseLiteDto.id">{{ caseLiteDto.year }}</option>
                </select>
                <select class="ml-3" v-model="selectedFramework" @change="handleFrameworkChanged()">
                  <option v-for="(framework, index) in frameworks" :key="index" :value="framework">{{ framework }}</option>
                </select>
              </span>
            </div>
            <div class="">
              <div class="table-responsive" style="overflow-x: hidden;">
                <table class="table" style="width:100%;color:#ffffff;">
                  <tr><td>Country</td><td>{{ casee.companyCountry }}</td></tr>
                  <tr><td>Industry</td><td>{{ casee.companyIndustry }}</td></tr>
                  <tr v-if="casee.companyParent"><td>Member of</td><td>{{ casee.companyParent }}</td></tr>
                  <tr v-if="casee.companySize"><td>Company Size</td><td>{{ casee.companySize }}</td></tr>
                  <tr v-if="casee.numberOfEmployees"><td>Employees</td><td>{{ formatNumber(casee.numberOfEmployees) }}</td></tr>
                  <tr v-if="casee.turnover"><td>Turnover</td><td>{{ formatNumber(casee.turnover) }}&nbsp;&euro;</td></tr>
                  <tr v-if="casee.totalAssets"><td>Total Assets</td><td>{{ formatNumber(casee.totalAssets) }}&nbsp;&euro;</td></tr>
                </table>
              </div>
            </div>
            <div class="form-group">
              <div class="input-group">
                <div class="input-group-prepend">
                  <span class="input-group-text">
                    <span class="ti-search"></span>
                  </span>
                </div>
                <input class="form-control" type="text" v-model.trim="searchQuestionsQuery" v-on:keyup.enter="filterQuestions();" placeholder="search question within topic">
                <div class="input-group-append">
                  <button class="btn btn-sm btn-primary" @click="filterQuestions();" type="button">Search</button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 col-lg-6">
          <div class="row">
            <div class="col-12">
              <div :class="{card:true, 'p-2':true, 'bg-gri': selectedPillar === 'gri', 'bg-general': selectedPillar === 'general', 'bg-environmental': selectedPillar === 'environmental', 'bg-social': selectedPillar === 'social', 'bg-governance': selectedPillar === 'governance', 'bg-financial': selectedPillar === 'financial'}">
                <ul class="pillar-filter">
                  <li v-for="(pillr,index) in pillars" :key="index" v-show="showPillarFilter" :class="{active: selectedPillar === pillr, pointer: true}" @click="selectedPillar=pillr;handleTreeItemClicked({item:topicsTree[pillr].childrenDtos[0], isCustom:false});">{{ pillr }}</li>
                </ul>
              </div>
            </div>
            <div class="col-12">
              <div :class="{card:true, 'p-2':true, 'bg-gri': selectedPillar === 'gri', 'bg-general': selectedPillar === 'general', 'bg-environmental': selectedPillar === 'environmental', 'bg-social': selectedPillar === 'social', 'bg-governance': selectedPillar === 'governance', 'bg-financial': selectedPillar === 'financial'}">
                <ul v-show="selectedPillar === 'gri'" class="questions_tree">
                  <tree-item
                    class="tree-item"
                    @treeItemClicked="handleTreeItemClicked"
                    :item="topicsTree.gri"
                    :is-custom="false"
                  ></tree-item>
                </ul>
                <ul v-show="selectedPillar === 'gri'" class="questions_tree">
                  <tree-item
                    class="tree-item"
                    @treeItemClicked="handleTreeItemClicked"
                    :item="customTopicsTree.gri"
                    :is-custom="true"
                  ></tree-item>
                </ul>
                <ul v-show="selectedPillar === 'general'" class="questions_tree">
                  <tree-item
                    class="tree-item"
                    @treeItemClicked="handleTreeItemClicked"
                    :item="topicsTree.general"
                    :is-custom="false"
                  ></tree-item>
                </ul>
                <ul v-show="selectedPillar === 'general'" class="questions_tree">
                  <tree-item
                    class="tree-item"
                    @treeItemClicked="handleTreeItemClicked"
                    :item="customTopicsTree.general"
                    :is-custom="true"
                  ></tree-item>
                </ul>
                <ul v-show="selectedPillar === 'environmental'" class="questions_tree">
                  <tree-item
                    class="tree-item"
                    @treeItemClicked="handleTreeItemClicked"
                    :item="topicsTree.environmental"
                    :is-custom="false"
                  ></tree-item>
                </ul>
                <ul v-show="selectedPillar === 'environmental'" class="questions_tree">
                  <tree-item
                    class="tree-item"
                    @treeItemClicked="handleTreeItemClicked"
                    :item="customTopicsTree.environmental"
                    :is-custom="true"
                  ></tree-item>
                </ul>
                <ul v-show="selectedPillar === 'social'" class="questions_tree">
                  <tree-item
                    class="tree-item"
                    @treeItemClicked="handleTreeItemClicked"
                    :item="topicsTree.social"
                    :is-custom="false"
                  ></tree-item>
                </ul>
                <ul v-show="selectedPillar === 'social'" class="questions_tree">
                  <tree-item
                    class="tree-item"
                    @treeItemClicked="handleTreeItemClicked"
                    :item="customTopicsTree.social"
                    :is-custom="true"
                  ></tree-item>
                </ul>
                <ul v-show="selectedPillar === 'governance'" class="questions_tree">
                  <tree-item
                    class="tree-item"
                    @treeItemClicked="handleTreeItemClicked"
                    :item="topicsTree.governance"
                    :is-custom="false"
                  ></tree-item>
                </ul>
                <ul v-show="selectedPillar === 'governance'" class="questions_tree">
                  <tree-item
                    class="tree-item"
                    @treeItemClicked="handleTreeItemClicked"
                    :item="customTopicsTree.governance"
                    :is-custom="true"
                  ></tree-item>
                </ul>
                <ul v-show="selectedPillar === 'financial'" class="questions_tree">
                  <tree-item
                    class="tree-item"
                    @treeItemClicked="handleTreeItemClicked"
                    :item="topicsTree.financial"
                    :is-custom="false"
                  ></tree-item>
                </ul>
                <ul v-show="selectedPillar === 'financial'" class="questions_tree">
                  <tree-item
                    class="tree-item"
                    @treeItemClicked="handleTreeItemClicked"
                    :item="customTopicsTree.financial"
                    :is-custom="true"
                  ></tree-item>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row mt-4">
        <div class="col-12">
          <div v-show="selectedPillar==='gri'" style="border: 1px solid #1d599f;height:250px;background-image: url('pillar-gri-hero.jpg');background-position:center;background-size: cover;"></div>
          <div v-show="selectedPillar==='environmental'" style="height:250px;background-image: url('pillar-e2-hero.jpg');background-position:center;background-size: cover;"></div>
          <div v-show="selectedPillar==='social'" style="height:250px;background-image: url('pillar-s-hero.jpg');background-position:top;background-size: cover;"></div>
          <div v-show="selectedPillar==='governance'" style="height:250px;background-image: url('pillar-g1-hero.jpg');background-position:center;background-size: cover;"></div>
          <div v-show="selectedPillar==='financial'" style="height:250px;background-image: url('pillar-f-hero.jpg');background-position:center;background-size: cover;"></div>
          <div v-show="selectedPillar==='general'" style="height:250px;background-image: url('pillar-f-hero.jpg');background-position:center;background-size: cover;"></div>
        </div>
      </div>

      <div class="row mt-5" v-if="questionsFetched && selectedTopic">
        <div class="col-12 col-sm-12 col-md-6 col-lg-4 col-xl-3" v-for="(questionDto, index) in topicsFlat[selectedTopic].questionDtos" :key="index" v-show="filteredOutQuestions.indexOf(questionDto.id) === -1">
          <div :class="{card:true, 'p-2':true, 'question-card':true, 'bg-gri': selectedPillar === 'gri', 'bg-general': selectedPillar === 'general', 'bg-environmental': selectedPillar === 'environmental', 'bg-social': selectedPillar === 'social', 'bg-governance': selectedPillar === 'governance', 'bg-financial': selectedPillar === 'financial'}">
            <div v-if="actions.canCreateEvaluation && actions.canUpdateEvaluation" class="question-edit pointer" @click="initEvaluationModal(questionDto, false);"><span class="ti-pencil"></span></div>
            <div v-else class="question-edit cursor-forbidden text-muted"><span class="ti-pencil"></span></div>
            <div v-if="questionDto.description" class="question-edit pointer" style="top: 32px;" @click="initInfoModal(questionDto.description);"><span class="ti-light-bulb"></span></div>
            <div class="pt-2 pb-2 pr-4">{{ questionDto.title }}</div>
            <hr>
            <div v-if="questionDto.evaluationId">
              <div v-if="questionDto.isNumericIndex">
                <div class="pull-left">{{ formatNumber(questionDto.analystAnswerNumeric) }}</div>
                <div class="pull-right pointer" v-if="questionDto.analystAnswerText && questionDto.analystAnswerText !== ''" @click="initInfoModal(questionDto.analystAnswerText);"><span>details</span>&nbsp;<span class="ti-info"></span></div>
                <div class="clear"></div>
              </div>
              <div v-else v-html="questionDto.analystAnswerText" class="question-answer-text text-muted"></div>
            </div>
            <div v-else>
              <div class="text-danger small">no data</div>
            </div>
          </div>
        </div>
        <div v-if="topicsFlat[selectedTopic].questionDtos.length===0 || topicsFlat[selectedTopic].questionDtos.length === filteredOutQuestions.length" class="col-12">
          <div class="card p-3">No Questions found</div>
        </div>
      </div>

      <div class="row mt-5" v-if="customQuestionsFetched && selectedCustomTopic">
        <div class="col-12 col-sm-12 col-md-6 col-lg-4 col-xl-3" v-for="(questionDto, index) in customTopicsFlat[selectedCustomTopic].questionDtos" :key="index" v-show="filteredOutQuestions.indexOf(questionDto.id) === -1">
          <div :class="{card:true, 'p-2':true, 'question-card':true, 'bg-gri': selectedPillar === 'gri', 'bg-general': selectedPillar === 'general', 'bg-environmental': selectedPillar === 'environmental', 'bg-social': selectedPillar === 'social', 'bg-governance': selectedPillar === 'governance', 'bg-financial': selectedPillar === 'financial'}">
            <div v-if="actions.canCreateCustomEvaluation && actions.canUpdateCustomEvaluation" class="question-edit pointer" @click="initEvaluationModal(questionDto, true);"><span class="ti-pencil"></span></div>
            <div v-else class="question-edit cursor-forbidden text-muted"><span class="ti-pencil"></span></div>
            <div v-if="actions.canDeleteCustomEvaluation" class="question-delete pointer" @click="initCustomQuestionDeleteModal(questionDto);"><span>&times;</span></div>
            <div v-else class="question-delete cursor-forbidden text-muted"><span>&times;</span></div>
            <div class="pt-2 pb-2 pr-4">{{ questionDto.title }}</div>
            <hr>
            <div v-if="questionDto.customEvaluationId">
              <div v-if="questionDto.isNumericIndex">
                <div class="pull-left">{{ formatNumber(questionDto.customAnswerNumeric) }}</div>
                <div class="pull-right pointer" v-if="questionDto.customAnswerText && questionDto.customAnswerText !== ''" @click="initInfoModal(questionDto.customAnswerText);"><span>details</span>&nbsp;<span class="ti-info"></span></div>
                <div class="clear"></div>
              </div>
              <div v-else v-html="questionDto.customAnswerText" class="question-answer-text text-muted"></div>
            </div>
            <div v-else>
              <div class="text-danger small">no data</div>
            </div>
          </div>
        </div>
        <div v-if="customTopicsFlat[selectedCustomTopic].questionDtos.length===0 || customTopicsFlat[selectedCustomTopic].questionDtos.length === filteredOutQuestions.length" class="col-12">
          <div class="card p-3">No custom Questions found</div>
        </div>
        <div class="col-12 col-sm-12 col-md-6 col-lg-4 col-xl-3">
          <div class="card p-2 question-card">
            <div>Add Custom Question</div>
            <hr>
            <div>
              <button class="btn btn-block btn-primary btn-sm" @click="initAddCustomQuestionModal">+ Add custom Question</button>
            </div>
          </div>
        </div>
      </div>

      <modal name="delete-case-modal" :draggable="false" height="auto" :scrollable="false" :clickToClose="false">
        <div style="position:relative;" class="p-3">
            <div style="position: absolute; top: 5px; right: 5px;">
              <button class="btn btn-sm btn-neutral" @click="$modal.hide('delete-case-modal')">&times;</button>
            </div>
            <div>
              <h5 class="card-title mb-4" style="margin-top:5px;">Are you sure you want to delete ESG data of <i>{{ casee.companyTradeTitle }} for year {{ casee.year }}</i>?</h5>
            </div>
            <hr>
            <div class="text-center">
              <button class="btn btn-neutral" @click="$modal.hide('delete-case-modal')">No</button>
              <button class="btn btn-danger" @click="deleteCase" :disabled="deletingCase">Yes<span v-if="deletingCase">...</span></button>
            </div>
        </div>
      </modal>

      <modal name="delete-custom-question-modal" :draggable="false" height="auto" :scrollable="false" :clickToClose="false">
        <div style="position:relative;" class="p-3">
            <div style="position: absolute; top: 5px; right: 5px;">
              <button class="btn btn-sm btn-neutral" @click="$modal.hide('delete-custom-question-modal')">&times;</button>
            </div>
            <div>
              <h5 class="card-title mb-4" style="margin-top:5px;">Are you sure you want to remove Custom Question <i>{{ customQuestionObject.title }}</i> from Questionnaire?</h5>
            </div>
            <hr>
            <div class="text-center">
              <button class="btn btn-neutral" @click="$modal.hide('delete-custom-question-modal')">No</button>
              <button class="btn btn-danger" @click="deleteCustomQuestion" :disabled="deletingCustomQuestion">Yes<span v-if="deletingCustomQuestion">...</span></button>
            </div>
        </div>
      </modal>

      <modal name="add-custom-question-modal" :draggable="true" height="auto" :scrollable="true" :clickToClose="false">
        <div style="position:relative;" class="p-3">
            <div style="position: absolute; top: 5px; right: 5px;">
              <button class="btn btn-sm btn-neutral" @click="$modal.hide('add-custom-question-modal')">&times;</button>
            </div>
            <div class="form-group">
              <label class="control-label">Add custom Criterion to questionnaire</label>
              <select class="form-control" v-model="customCriterionToAdd">
                <option :value="null">Select custom Criterion to add</option>
                <option v-for="(customCriterion, index) in customCriteriaByTopic" :key="index" :value="customCriterion">{{ customCriterion.title }}</option>
              </select>
            </div>
            <hr>
            <div class="text-center">
              <button class="btn btn-neutral" @click="$modal.hide('add-custom-question-modal')">Close</button>
              <button class="btn btn-success" @click="addCustomQuestion" :disabled="addingCustomQuestion">Yes<span v-if="addingCustomQuestion">...</span></button>
            </div>
        </div>
      </modal>

      <modal name="complete-case-modal" :draggable="false" height="auto" :scrollable="false" :clickToClose="false">
        <div style="position:relative;" class="p-3">
            <div style="position: absolute; top: 5px; right: 5px;">
              <button class="btn btn-sm btn-neutral" @click="$modal.hide('complete-case-modal')">&times;</button>
            </div>
            <div>
              <h5 class="card-title mb-4" style="margin-top:5px;">Are you sure you want to mark case <i>{{ casee.companyTradeTitle }}</i> as completed? You will not be able to revert this action</h5>
            </div>
            <hr>
            <div class="text-center">
              <button class="btn btn-neutral" @click="$modal.hide('complete-case-modal')">No</button>
              <button class="btn btn-success" @click="completeCase" :disabled="completingCase">Yes<span v-if="completingCase">...</span></button>
            </div>
        </div>
      </modal>

      <modal v-if="caseLoaded" name="evaluation-modal" :draggable="true" height="auto" :scrollable="true" :clickToClose="false">
        <div style="position:relative;" class="p-3">
          <div style="position: absolute; top: 5px; right: 5px;">
            <button class="btn btn-sm btn-neutral" @click="$modal.hide('evaluation-modal')">&times;</button>
          </div>
          
          <h4 v-if="evaluationObject.id">Edit&nbsp;Answer</h4>
          <h4 v-else>New&nbsp;Answer</h4>
      
          <p>{{ evaluationObject.questionTitle }}</p>

          <div class="form-group">
            <label v-if="evaluationObject.questionMeta && evaluationObject.questionMeta.expectsBooleanAnswer" class="control-label">Boolean answer</label>
            <label v-else class="control-label">Numeric answer</label>
            <div v-if="evaluationObject.id" class="input-group">
              <select class="form-control" v-if="evaluationObject.questionMeta && evaluationObject.questionMeta.expectsBooleanAnswer" v-model="evaluationObject.analystAnswerNumeric">
                <option :value="null">Pick one option</option>
                <option :value="'1'">Yes</option>
                <option :value="'0'">No</option>
                <option :value="'0.5'">Partially</option>
              </select>
              <input v-else class="form-control" type="text" :value="evaluationObject.analystAnswerNumeric" @input="evaluationObject.analystAnswerNumeric = withThousandsSeparator(withoutThousandsSeparator($event.target.value.trim()))">
              <div class="input-group-append">
                <button class="btn btn-sm btn-secondary" type="button" @click="saveEvaluationAnalystAnswerNumeric()" :disabled="casee.status === 'completed'">Save</button>
              </div>
            </div>
            <div v-else>
              <select class="form-control" v-if="evaluationObject.questionMeta && evaluationObject.questionMeta.expectsBooleanAnswer" v-model="evaluationObject.analystAnswerNumeric">
                <option :value="null">Pick one option</option>
                <option :value="'1'">Yes</option>
                <option :value="'0'">No</option>
                <option :value="'0.5'">Partially</option>
              </select>
              <input v-else type="text" class="form-control" :value="evaluationObject.analystAnswerNumeric" @input="evaluationObject.analystAnswerNumeric = withThousandsSeparator(withoutThousandsSeparator($event.target.value.trim()))">
            </div>
            <div class="">
              <small v-if="evaluationObject.questionMeta && evaluationObject.questionMeta.expectsBooleanAnswer" class="text-muted">Year {{ casee.year-1 }}: {{ (latestEvaluationObject.analystAnswerNumeric === null) ? '-' : numericToBooleanAnswer(latestEvaluationObject.analystAnswerNumeric) }}</small>
              <small v-else class="text-muted">Year {{ casee.year-1 }}: {{ (latestEvaluationObject.analystAnswerNumeric === null) ? '-' : latestEvaluationObject.analystAnswerNumeric }}</small>
              <a href="javascript:void(0);" v-if="evaluationHistoryData" class="pull-right" @click="showEvaluationHistoryData=!showEvaluationHistoryData">
                <small v-if="showEvaluationHistoryData">hide history</small>
                <small v-else>show history</small>
              </a>
              <div v-show="showEvaluationHistoryData">
                <line-chart v-if="evaluationHistoryData" :height="200" :chart-data="evaluationHistoryData" :extra-options="{responsive: true, maintainAspectRatio: true}"></line-chart>
              </div>
            </div>

          </div>

          <div class="form-group">
            <label class="control-label">Answer</label>
            <div v-if="evaluationObject.questionMeta && evaluationObject.questionMeta.allowedValues.length > 0">
              <div v-if="evaluationObject.id" class="input-group">
                <select class="form-control" v-model="evaluationObject.analystAnswerText" >
                  <option :value="''">Select a value</option>
                  <option v-for="(allowedValue, index) in evaluationObject.questionMeta.allowedValues" :key="index" :value="allowedValue">{{ allowedValue }}</option>
                </select>
                <div class="input-group-append">
                  <button class="btn btn-sm btn-secondary" type="button" @click="saveEvaluationAnalystAnswerText(false)" :disabled="casee.status === 'completed'">Save</button>
                </div>
              </div>
              <select v-else class="form-control" v-model="evaluationObject.analystAnswerText" >
                <option :value="''">Select a value</option>
                <option v-for="(allowedValue, index) in evaluationObject.questionMeta.allowedValues" :key="index" :value="allowedValue">{{ allowedValue }}</option>
              </select>
              <div class=""><small class="text-muted">Year {{ casee.year-1 }}: <span v-html="(latestEvaluationObject.analystAnswerText === '') ? '-' : latestEvaluationObject.analystAnswerText"></span></small></div>
            </div>
            <div v-else>
              <quill-editor ref="quillEditor" content-type="html" theme="snow" toolbar="essential" v-model="evaluationObject.analystAnswerText" :readOnly="casee.status === 'completed'"/>
              <div class=""><small class="text-muted">Year {{ casee.year-1 }}: <span v-html="(latestEvaluationObject.analystAnswerText === '') ? '-' : latestEvaluationObject.analystAnswerText"></span></small></div>
              <div class="text-right">
                <button v-if="evaluationObject.id" type="button" class="btn btn-sm btn-secondary" @click="saveEvaluationAnalystAnswerText(false)" :disabled="casee.status === 'completed'">Save</button>
              </div>
            </div>        
          </div>

          <!-- <div class="form-group">
            <label class="control-label">Source</label>        
            <quill-editor ref="quillEditorSource" content-type="html" theme="snow" toolbar="essential" v-model="evaluationObject.source" :readOnly="casee.status === 'completed'"/>
            <div class=""><small class="text-muted">Year {{ casee.year-1 }}: <span v-html="(latestEvaluationObject.source === '') ? '-' : latestEvaluationObject.source"></span></small></div>
            <div class="text-right">
              <button v-if="evaluationObject.id" type="button" class="btn btn-sm btn-secondary" @click="saveEvaluationSource" :disabled="casee.status === 'completed'">Save</button>
            </div>
          </div> -->

          <div class="form-group">
            <label class="control-label">Notes (internal use)</label>        
            <quill-editor ref="quillEditorNotes" content-type="html" theme="snow" toolbar="essential" v-model="evaluationObject.analystNotes" :readOnly="casee.status === 'completed'"/>
            <div class=""><small class="text-muted">Year {{ casee.year-1 }}: <span v-html="(latestEvaluationObject.analystNotes === '') ? '-' : latestEvaluationObject.analystNotes"></span></small></div>
            <div class="text-right">
              <button v-if="evaluationObject.id" type="button" class="btn btn-sm btn-secondary" @click="saveEvaluationAnalystNotes" :disabled="casee.status === 'completed'">Save</button>
            </div>
          </div>
          <hr>
          <div v-if="showDeleteEvaluationModal" class="p-3 text-center">
            <div>
              <h5>Are you sure you want to delete your answer?</h5>
            </div>
            <div class="">
              <button class="btn btn-neutral" @click="showDeleteEvaluationModal=false">No</button>
              <button class="btn btn-danger" @click="deleteEvaluation" :disabled="deletingEvaluation">Yes, delete it<span v-if="deletingEvaluation">...</span></button>
            </div>
          </div>
          <div v-else class="text-center">
            <button class="btn btn-neutral" @click="$modal.hide('evaluation-modal');">Close</button>
            <button v-if="evaluationObject.id" :class="{btn:true, 'btn-danger':true, 'cursor-forbidden':!actions.canDeleteEvaluation}" @click="initEvaluationDeleteModal(evaluationObject)" :disabled="!actions.canDeleteEvaluation || casee.status === 'completed'">Delete</button>
            <button v-else class="btn btn-success" @click="createEvaluation(false)" :disabled="casee.status === 'completed'">Save</button>
          </div>
        </div>
      </modal>

      <modal name="info-modal" :draggable="false" height="auto" :scrollable="false" :clickToClose="true">
        <div style="position:relative;" class="p-3">
            <div style="position: absolute; top: 5px; right: 5px;">
              <button class="btn btn-sm btn-neutral" @click="$modal.hide('info-modal')">&times;</button>
            </div>
            <div v-html="infoTextSlot"></div>
            <hr>
            <div class="text-center">
              <button class="btn btn-neutral" @click="$modal.hide('info-modal')">Close</button>
            </div>
        </div>
      </modal>
    </div>
</template>
<script>
import Api from "../api";
import TreeItem from "../components/TreeItem";
import { quillEditor } from 'vue-quill-editor';
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import LineChart from "../components/Charts/LineChart";
export default {
  components: {
    TreeItem,
    quillEditor,
    LineChart
  },
  data() {
    return {
      caseLoaded: false,
      savingCasePublic: false,
      deletingCase: false,
      completingCase: false,
      incompletingCase: false,
      deletingEvaluation: false,
      addingCustomQuestion: false,
      deletingCustomQuestion: false,
      showDeleteEvaluationModal: false,
      errorMessage: '',

      questionsFetched: false,
      customQuestionsFetched: false,
      searchQuestionsQuery: '',
      filteredOutQuestions: [],
      companyCases: [],

      casee: {
        id: parseInt(this.$route.params.id),
        companyId: null,
        year: null,
        status: '',
        isPublic: true,
        companyTradeTitle: '',
        companyCountry: '',
        companyIndustry: '',
        companyParent: null,
        companyLogoPath: null,
        numberOfEmployees: null,
        turnover: null,
        totalAssets: null,
        companySize: null
      },

      customQuestionObject: {
        id: null,
        title: ''
      },
      pillars: ['environmental'],
      selectedPillar: 'environmental',
      selectedTopic: null,
      selectedCustomTopic: null,
      selectedCaseId: null,

      topicsTree: {
        gri: {
          title: 'System GRI Topics',
          id: null,
          childrenDtos: []
        },
        environmental: {
          title: 'System Environmental Topics',
          id: null,
          childrenDtos: []
        },
        social: {
          title: 'System Social Topics',
          id: null,
          childrenDtos: []
        },
        governance: {
          title: 'System Governance Topics',
          id: null,
          childrenDtos: []
        },
        financial: {
          title: 'System Financial Topics',
          id: null,
          childrenDtos: []
        },
        general: {
          title: 'System General Topics',
          id: null,
          childrenDtos: []
        },
      },
      topicsFlat: {},

      customTopicsTree: {
        gri: {
          title: 'Custom GRI Topics',
          id: null,
          childrenDtos: []
        },
        environmental: {
          title: 'Custom Environmental Topics',
          id: null,
          childrenDtos: []
        },
        social: {
          title: 'Custom Social Topics',
          id: null,
          childrenDtos: []
        },
        governance: {
          title: 'Custom Governance Topics',
          id: null,
          childrenDtos: []
        },
        financial: {
          title: 'Custom Financial Topics',
          id: null,
          childrenDtos: []
        },
        general: {
          title: 'Custom General Topics',
          id: null,
          childrenDtos: []
        },
      },
      customTopicsFlat: {},

      evaluationObject: {
        id: null,
        criterionId: null,
        questionId: null,
        questionTitle: '',
        questionMeta: null,
        analystAnswerNumeric: null,
        analystAnswerText: "",
        analystNotes: "",
        source: "",
        analystGrade: null,
        metaDto: {
          isEducatedGuess: false
        },
        isCustom: false
      },

      latestEvaluationObject: {
        id: null,
        criterionId: null,
        questionId: null,
        questionTitle: '',
        questionMeta: null,
        analystAnswerNumeric: null,
        analystAnswerText: "",
        analystNotes: "",
        source: "",
        analystGrade: null,
        metaDto: {
          isEducatedGuess: false
        }
      },

      showEvaluationHistoryData: false,
      evaluationHistoryData: null,

      infoTextSlot: null,

      actions : {
        canUpdateCase: this.$root.canUserDo(['case_update']),
        canDeleteCase: this.$root.canUserDo(['case_delete']),
        canUpdateCaseStatus: this.$root.canUserDo(['case_update_status']),
        canCreateEvaluation: this.$root.canUserDo(['evaluation_create']),
        canUpdateEvaluation: this.$root.canUserDo(['evaluation_update_analyst_answer']),
        canDeleteEvaluation: this.$root.canUserDo(['evaluation_delete']),
        canCreateCustomEvaluation: this.$root.canUserDo(['custom_evaluation_create']),
        canUpdateCustomEvaluation: this.$root.canUserDo(['custom_evaluation_update_answer']),
        canDeleteCustomEvaluation: this.$root.canUserDo(['custom_evaluation_delete']),
      },

      customQuestionsFlat: {},
      customCriteriaByTopic: [],
      customCriterionToAdd: null,

      frameworks: ['nza'],
      selectedFramework: 'nza',
    };
  },
  mounted() {
    this.fetchFrameworks();
  },
  methods: {

    fetchFrameworks() {
      let self = this;
      Api.send('GET', '/frameworks', {}, false)
      .then((response) => {
        self.frameworks = response;
        self.selectedFramework = response[0];
        self.fetchPillars();
      })
      .catch((err) => {
        self.errorMessage = err.msg;
      });
    },
    fetchPillars() {
      let self = this;
      Api.send('GET', '/pillars', {}, false)
      .then((response) => {
        self.pillars = response;
        self.selectedPillar = response[0];
        self.fetchCase();
      })
      .catch((err) => {
        self.errorMessage = err.msg;
      });
    },

    resetCase() {
      this.casee.companyId = null;
      this.casee.year = null;
      this.casee.status = '';
      this.casee.isPublic = true;
      this.casee.companyTradeTitle = '';
      this.casee.companyCountry = '';
      this.casee.companyIndustry = '';
      this.casee.companyParent = null;
      this.casee.companyLogoPath = null;
      this.casee.numberOfEmployees = null,
      this.casee.turnover = null,
      this.casee.totalAssets = null,
      this.casee.companySize = null
    },

    resetEvaluationObject() {
      this.evaluationObject.id = null;
      this.evaluationObject.criterionId = null;
      this.evaluationObject.questionId = null;
      this.evaluationObject.questionTitle = '';
      this.evaluationObject.questionMeta = null;
      this.evaluationObject.analystAnswerNumeric = null;
      this.evaluationObject.analystAnswerText = '';
      this.evaluationObject.analystNotes = '';
      this.evaluationObject.source = '';
      this.evaluationObject.analystGrade = null;
      this.evaluationObject.metaDto.isEducatedGuess = false;
      this.evaluationObject.isCustom = false;
    },

    resetLatestEvaluationObject() {
      this.latestEvaluationObject.id = null;
      this.latestEvaluationObject.criterionId = null;
      this.latestEvaluationObject.questionId = null;
      this.latestEvaluationObject.questionTitle = '';
      this.latestEvaluationObject.questionMeta = null;
      this.latestEvaluationObject.analystAnswerNumeric = null;
      this.latestEvaluationObject.analystAnswerText = '';
      this.latestEvaluationObject.analystNotes = '';
      this.latestEvaluationObject.source = '';
      this.latestEvaluationObject.analystGrade = null;
      this.latestEvaluationObject.metaDto.isEducatedGuess = false;
    },

    initDeleteCaseModal() {
      if (!this.casee.id) {
        return false;
      }
      this.$modal.show('delete-case-modal');
    },

    initCompleteCaseModal() {
      if (!this.casee.id) {
        return false;
      }
      this.$modal.show('complete-case-modal');
    },

    initEvaluationModal(item, isCustom) {
      let self = this;
      self.showDeleteEvaluationModal = false;
      if (item.evaluationId || item.customEvaluationId) {
        const url = (isCustom) ? '/custom_evaluations/' + item.customEvaluationId + '' : '/evaluations/' + item.evaluationId + '' ;
        Api.send('GET', url, {})
        .then((response) => {
          self.evaluationObject.isCustom = isCustom;
          self.evaluationObject.id = response.id;
          self.evaluationObject.questionTitle = item.title;
          self.evaluationObject.metaDto.isEducatedGuess = (response.metaDto.isEducatedGuess) ? true : false;
          if (self.evaluationObject.isCustom) {
            self.evaluationObject.criterionId = response.customQuestionDto.customCriterionDto.id;
            self.evaluationObject.questionId = response.customQuestionDto.id;
            self.evaluationObject.questionMeta = response.customQuestionDto.customCriterionDto.metaDto;
            self.evaluationObject.analystAnswerNumeric = self.withThousandsSeparator(response.customAnswerNumeric);
            self.evaluationObject.analystAnswerText = (response.customAnswerText) ? response.customAnswerText : '';
            self.evaluationObject.analystNotes = (response.customNotes) ? response.customNotes : '';
            self.evaluationObject.source = '';
            self.evaluationObject.analystGrade = null;
          } else {
            self.evaluationObject.criterionId = response.questionDto.criterionDto.id;
            self.evaluationObject.questionId = response.questionDto.id;
            self.evaluationObject.questionMeta = response.questionDto.criterionDto.metaDto;
            self.evaluationObject.analystAnswerNumeric = self.withThousandsSeparator(response.analystAnswerNumeric);
            self.evaluationObject.analystAnswerText = (response.analystAnswerText) ? response.analystAnswerText : '';
            self.evaluationObject.analystNotes = (response.analystNotes) ? response.analystNotes : '';
            self.evaluationObject.source = (response.source) ? response.source : '';
            self.evaluationObject.analystGrade = response.analystGrade;
          }

          self.$modal.show('evaluation-modal');
          self.fetchLatestEvaluation();
        })
        .catch((err) => {
          self.$root.notifyy('danger', err.msg);
          self.resetEvaluationObject();
          self.$modal.show('evaluation-modal');
        });
      } else {
        self.resetEvaluationObject();
        self.evaluationObject.questionId = item.id;
        self.evaluationObject.questionTitle = item.title;
        self.evaluationObject.isCustom = isCustom;
        const url = (isCustom) ? '/custom_questions/' + item.id + '' : '/questions/' + item.id + '';
        Api.send('GET', url, {})
        .then((response) => {
          if (self.evaluationObject.isCustom) {
            self.evaluationObject.criterionId = response.customCriterionDto.id;
            self.evaluationObject.questionMeta = response.customCriterionDto.metaDto;
          } else {
            self.evaluationObject.criterionId = response.criterionDto.id;
            self.evaluationObject.questionMeta = response.criterionDto.metaDto;
          }
          self.$modal.show('evaluation-modal');
          self.fetchLatestEvaluation();
        })
        .catch((err) => {
          self.$root.notifyy('danger', err.msg);
          self.$modal.show('evaluation-modal');
        });
      }
    },

    initEvaluationDeleteModal(item) {
      if (!item.id) {
        return false;
      }
      this.evaluationObject.id = item.id;
      this.showDeleteEvaluationModal = true;
    },

    initCustomQuestionDeleteModal(item) {
      if (!item.id) {
        return false;
      }
      this.customQuestionObject.id = item.id;
      this.customQuestionObject.title = item.title;
      this.$modal.show('delete-custom-question-modal');
    },

    initInfoModal(text) {
      this.infoTextSlot = text;
      this.$modal.show('info-modal');
    },

    fetchCase() {
      let self = this;
      self.errorMessage = '';
      Api.send("GET", "/cases/" + self.casee.id + "", {})
        .then((response) => {
          self.casee.companyId = response.companyDto.id;
          self.casee.year = response.year;
          self.casee.status = response.status;
          self.casee.isPublic = response.isPublic;
          self.casee.companyTradeTitle = response.companyDto.tradeTitle;
          self.casee.companyCountry = response.companyDto.addressDto.regionalUnitDto.regionDto.countryDto.title;
          self.casee.companyIndustry = '(' + response.companyDto.industryDto.naceCode + ') ' + response.companyDto.industryDto.title;
          self.casee.companyParent = (response.companyDto.parentDto) ? response.companyDto.parentDto.tradeTitle : null;
          self.casee.companyLogoPath = response.companyDto.logoPath;
          self.caseLoaded = true;
          self.fetchTopicsTree();
          self.fetchCompanyCases();
        })
        .catch((err) => {
          self.resetCase();
          self.errorMessage = err.msg;
        })
        .finally(() => {
          
        });
    },

    fetchCompanyCases() {
      let self = this;
      if (!self.casee.companyId) {
        return false;
      }
      self.errorMessage = '';
      Api.send("GET", "/companies/" + self.casee.companyId + "/cases", {})
        .then((response) => {
          self.companyCases = response;
          self.selectedCaseId = self.casee.id;
        })
        .catch((err) => {
          self.companyCases = [];
          self.errorMessage = err.msg;
        })
        .finally(() => {
          
        });
    },

    deleteCase() {
      let self = this;
      if (!self.casee.id) {
        return false;
      }
      self.deletingCase = true;
      Api.send('DELETE', '/cases/' + self.casee.id, {})
      .then((response) => {
        self.$modal.hide('delete-case-modal');
        self.$root.notifyy('success', response.msg);
        self.$router.push({path:'/'});
      })
      .catch((err) => {
        self.$root.notifyy('danger', err.msg);
      })
      .finally(() => {
        self.deletingCase = false;
      });
    },

    completeCase() {
      let self = this;
      if (!self.casee.id) {
        return false;
      }
      self.completingCase = true;
      Api.send('PATCH', '/cases/' + self.casee.id + '/status/completed', {})
      .then((response) => {
        self.$modal.hide('complete-case-modal');
        self.$root.notifyy('success', response.msg);
      })
      .catch((err) => {
        self.$root.notifyy('danger', err.msg);
      })
      .finally(() => {
        self.completingCase = false;
      });
    },

    incompleteCase() {
      let self = this;
      if (!self.casee.id) {
        return false;
      }
      self.incompletingCase = true;
      Api.send('PATCH', '/cases/' + self.casee.id + '/status/not_completed', {})
      .then((response) => {
        self.$root.notifyy('success', response.msg);
      })
      .catch((err) => {
        self.$root.notifyy('danger', err.msg);
      })
      .finally(() => {
        self.incompletingCase = false;
      });
    },

    fetchTopicsTree() {
      let self = this;
      Api.send('GET', '/topics/all/tree?framework=' + self.selectedFramework, {})
      .then((response) => {
        self.errorMessage = '';
        self.topicsTree.gri.childrenDtos = response.gri;
        self.topicsTree.environmental.childrenDtos = response.environmental;
        self.topicsTree.social.childrenDtos = response.social;
        self.topicsTree.governance.childrenDtos = response.governance;
        self.topicsTree.financial.childrenDtos = response.financial;
        self.topicsTree.general.childrenDtos = response.general;
        self.registerTopicsFlat();
        self.fetchCustomTopicsTree();
      })
      .catch((err) => {
        self.errorMessage = err.msg;
        self.topicsTree.gri.childrenDtos = [];
        self.topicsTree.environmental.childrenDtos = [];
        self.topicsTree.social.childrenDtos = [];
        self.topicsTree.governance.childrenDtos = [];
        self.topicsTree.financial.childrenDtos = [];
        self.topicsTree.general.childrenDtos = [];
      });
    },

    fetchCustomTopicsTree() {
      let self = this;
      Api.send('GET', '/custom_topics/' + self.casee.companyId + '/all/tree', {})
      .then((response) => {
        self.errorMessage = '';
        self.customTopicsTree.gri.childrenDtos = response.gri;
        self.customTopicsTree.environmental.childrenDtos = response.environmental;
        self.customTopicsTree.social.childrenDtos = response.social;
        self.customTopicsTree.governance.childrenDtos = response.governance;
        self.customTopicsTree.financial.childrenDtos = response.financial;
        self.customTopicsTree.general.childrenDtos = response.general;
        self.registerCustomTopicsFlat();
      })
      .catch((err) => {
        self.errorMessage = err.msg;
        self.customTopicsTree.gri.childrenDtos = [];
        self.customTopicsTree.environmental.childrenDtos = [];
        self.customTopicsTree.social.childrenDtos = [];
        self.customTopicsTree.governance.childrenDtos = [];
        self.customTopicsTree.financial.childrenDtos = [];
        self.customTopicsTree.general.childrenDtos = [];
      });
    },

    registerCustomTopicsFlat() {
      this.customTopicsFlat = {};
      for (let i in this.customTopicsTree.gri.childrenDtos) {
        this.registerCustomChildren(this.customTopicsTree.gri.childrenDtos[i]);
      }
      for (let i in this.customTopicsTree.environmental.childrenDtos) {
        this.registerCustomChildren(this.customTopicsTree.environmental.childrenDtos[i]);
      }
      for (let i in this.customTopicsTree.social.childrenDtos) {
        this.registerCustomChildren(this.customTopicsTree.social.childrenDtos[i]);
      }
      for (let i in this.customTopicsTree.governance.childrenDtos) {
        this.registerCustomChildren(this.customTopicsTree.governance.childrenDtos[i]);
      }
      for (let i in this.customTopicsTree.financial.childrenDtos) {
        this.registerCustomChildren(this.customTopicsTree.financial.childrenDtos[i]);
      }
      for (let i in this.customTopicsTree.general.childrenDtos) {
        this.registerCustomChildren(this.customTopicsTree.general.childrenDtos[i]);
      }
      this.fetchCustomQuestions();
    },
    registerCustomChildren(item) {
      item.criteriaDtos = null;
      this.customTopicsFlat[item.id] = item;
      this.customTopicsFlat[item.id]['questionDtos'] = [];
      if (item.childrenDtos.length > 0) {
        for (let i in item.childrenDtos) {
          this.registerCustomChildren(item.childrenDtos[i])
        }
      }
    },

    registerTopicsFlat() {
      this.topicsFlat = {};
      for (let i in this.topicsTree.gri.childrenDtos) {
        this.registerChildren(this.topicsTree.gri.childrenDtos[i]);
      }
      for (let i in this.topicsTree.environmental.childrenDtos) {
        this.registerChildren(this.topicsTree.environmental.childrenDtos[i]);
      }
      for (let i in this.topicsTree.social.childrenDtos) {
        this.registerChildren(this.topicsTree.social.childrenDtos[i]);
      }
      for (let i in this.topicsTree.governance.childrenDtos) {
        this.registerChildren(this.topicsTree.governance.childrenDtos[i]);
      }
      for (let i in this.topicsTree.financial.childrenDtos) {
        this.registerChildren(this.topicsTree.financial.childrenDtos[i]);
      }
      for (let i in this.topicsTree.general.childrenDtos) {
        this.registerChildren(this.topicsTree.general.childrenDtos[i]);
      }
      this.fetchQuestions();
    },
    registerChildren(item) {
      item.criteriaDtos = null;
      this.topicsFlat[item.id] = item;
      this.topicsFlat[item.id]['questionDtos'] = [];
      if (item.childrenDtos.length > 0) {
        for (let i in item.childrenDtos) {
          this.registerChildren(item.childrenDtos[i])
        }
      }
    },

    fetchQuestions() {
      let self = this;
      Api.send('GET', '/cases/' + self.casee.id + '/questions?frameworks[]=' + self.selectedFramework, {})
      .then((response) => {
        self.errorMessage = '';
        self.questionsFetched = false;
        for (let topicId in self.topicsFlat) {
          self.topicsFlat[topicId]['questionDtos'] = [];
        }
        for (let i in response) {
          self.topicsFlat[response[i]['topicId']]['questionDtos'].push(response[i]);
          switch(response[i]['criterionId']) {
            case 45:
              self.casee.numberOfEmployees = response[i]['analystAnswerNumeric'];
              break;
            case 139:
              self.casee.turnover = response[i]['analystAnswerNumeric'];
              break;
            case 140:
              self.casee.totalAssets = response[i]['analystAnswerNumeric'];
              break;
            case 203:
              self.casee.companySize = response[i]['analystAnswerText'];
              break;
          }
        }
        self.questionsFetched = true;
        if (!self.selectedTopic && !self.selectedCustomTopic) {
          if (self.selectedFramework === 'gri2021') {
            self.handleTreeItemClicked({item:self.topicsTree.gri.childrenDtos[0], isCustom: false});
          } else if (['vsme_basic', 'vsme_comprehensive'].indexOf(self.selectedFramework) > -1) {
            self.handleTreeItemClicked({item:self.topicsTree.general.childrenDtos[0], isCustom: false});
          } else {
            self.handleTreeItemClicked({item:self.topicsTree.environmental.childrenDtos[0], isCustom: false});
          }
        }
      })
      .catch((err) => {
        self.errorMessage = err.msg;
      });
    },

    fetchCustomQuestions() {
      let self = this;
      Api.send('GET', '/cases/' + self.casee.id + '/custom_questions', {})
      .then((response) => {
        self.errorMessage = '';
        self.customQuestionsFetched = false;
        self.customQuestionsFlat = {};
        for (let topicId in self.customTopicsFlat) {
          self.customTopicsFlat[topicId]['questionDtos'] = [];
        }
        for (let i in response) {
          self.customTopicsFlat[response[i]['customTopicId']]['questionDtos'].push(response[i]);
          self.customQuestionsFlat[response[i]['customCriterionId']] = response[i];
        }
        self.customQuestionsFetched = true;
      })
      .catch((err) => {
        self.errorMessage = err.msg;
      });
    },

    createEvaluation(stripTags) {
      let self = this;
      self.evaluationObject.analystAnswerText = self.evaluationObject.analystAnswerText.replace(/<p>(<br>|\s+)<\/p>/g, '');
      if (stripTags) {
        self.evaluationObject.analystAnswerText = self.stripHtml(self.evaluationObject.analystAnswerText);
      }
      self.evaluationObject.analystNotes = self.evaluationObject.analystNotes.replace(/<p>(<br>|\s+)<\/p>/g, '');
      self.evaluationObject.source = self.evaluationObject.source.replace(/<p>(<br>|\s+)<\/p>/g, '');
      let url = '';
      let data = {};
      if (self.evaluationObject.isCustom) {
        url = '/custom_questions/' + self.evaluationObject.questionId + '/custom_evaluations';
        data = {
          customAnswerNumeric: self.withoutThousandsSeparator(self.evaluationObject.analystAnswerNumeric), 
          customAnswerText: self.evaluationObject.analystAnswerText,
          customNotes: self.evaluationObject.analystNotes, 
          isEducatedGuess: self.evaluationObject.metaDto.isEducatedGuess
        };
      } else {
        url = '/questions/' + self.evaluationObject.questionId + '/evaluations';
        data = {
          analystAnswerNumeric: self.withoutThousandsSeparator(self.evaluationObject.analystAnswerNumeric), 
          analystAnswerText: self.evaluationObject.analystAnswerText,
          analystNotes: self.evaluationObject.analystNotes, 
          source: self.evaluationObject.source, 
          analystGrade: self.evaluationObject.analystGrade,
          isEducatedGuess: self.evaluationObject.metaDto.isEducatedGuess
        };
      }
      Api.send('POST', url, data)
      .then((response) => {
        self.$root.notifyy('success', response.msg);
        self.evaluationObject.id = response.data.id;
        if (self.evaluationObject.isCustom) {
          self.fetchCustomQuestions();
        } else {
          self.fetchQuestions();
        }
      })
      .catch((err) => {
        self.$root.notifyy('danger', err.msg);
      });
    },

    fetchLatestEvaluation() {
      let self = this;
      self.showEvaluationHistoryData = false;
      self.evaluationHistoryData = null;
      self.resetLatestEvaluationObject();
      const url = (self.evaluationObject.isCustom) ? '/custom_criteria/' + self.evaluationObject.criterionId + '/companies/' + self.casee.companyId + '/custom_evaluations?year=' + (self.casee.year-1) : '/criteria/' + self.evaluationObject.criterionId + '/companies/' + self.casee.companyId + '/evaluations?as_history=1&year=' + (self.casee.year-1);
      Api.send('GET', url, {})
      .then((responseArray) => {
          let dataset = {
            label: self.evaluationObject.questionTitle,
            data: []
          };
          let labels = [];
          let historyDataPoints = 0;
          for (let k in responseArray) {
            if (responseArray[k] && responseArray[k]['analystAnswerNumeric'] !== null) {
              historyDataPoints++;
              dataset.data.push(responseArray[k]['analystAnswerNumeric'])
            } else {
              dataset.data.push(null)
            }
            labels.push(k);
          }
          if (historyDataPoints > 1) {
            self.evaluationHistoryData = {
              datasets: [dataset],
              labels: labels
            };
          } else {
            self.evaluationHistoryData = null;
          }
          if (!responseArray[self.casee.year-1]) {
            self.resetLatestEvaluationObject();
            return false;
          }
          const response = responseArray[self.casee.year-1];
          self.latestEvaluationObject.id = response.id;
          self.latestEvaluationObject.questionTitle = '';
          self.latestEvaluationObject.metaDto.isEducatedGuess = (response.metaDto.isEducatedGuess) ? true : false;
          if (self.evaluationObject.isCustom) {
            self.latestEvaluationObject.criterionId = response.customQuestionDto.customCriterionDto.id;
            self.latestEvaluationObject.questionId = response.customQuestionDto.id;
            self.latestEvaluationObject.questionMeta = response.customQuestionDto.customCriterionDto.metaDto;
            self.latestEvaluationObject.analystAnswerNumeric = self.withThousandsSeparator(response.customAnswerNumeric);
            self.latestEvaluationObject.analystAnswerText = (response.customAnswerText) ? response.customAnswerText : '';
            self.latestEvaluationObject.analystNotes = (response.customNotes) ? response.customNotes : '';
            self.latestEvaluationObject.source = '';
            self.latestEvaluationObject.analystGrade = null;
          } else {
            self.latestEvaluationObject.criterionId = response.questionDto.criterionDto.id;
            self.latestEvaluationObject.questionId = response.questionDto.id;
            self.latestEvaluationObject.questionMeta = response.questionDto.criterionDto.metaDto;
            self.latestEvaluationObject.analystAnswerNumeric = self.withThousandsSeparator(response.analystAnswerNumeric);
            self.latestEvaluationObject.analystAnswerText = (response.analystAnswerText) ? response.analystAnswerText : '';
            self.latestEvaluationObject.analystNotes = (response.analystNotes) ? response.analystNotes : '';
            self.latestEvaluationObject.source = (response.source) ? response.source : '';
            self.latestEvaluationObject.analystGrade = response.analystGrade;
          }
      })
      .catch(() => {
        self.resetLatestEvaluationObject();
        self.evaluationHistoryData = null;
        self.showEvaluationHistoryData = false;
      });
    },

    saveEvaluationAnalystAnswerText(stripTags) {
      let self = this;
      if (!self.evaluationObject.id) {
        return false;
      }
      self.evaluationObject.analystAnswerText = self.evaluationObject.analystAnswerText.replace(/<p>(<br>|\s+)<\/p>/g, '');
      if (stripTags) {
        self.evaluationObject.analystAnswerText = self.stripHtml(self.evaluationObject.analystAnswerText);
      }
      let url = '';
      let data = {};
      if (self.evaluationObject.isCustom) {
        url = '/custom_evaluations/' + self.evaluationObject.id + '/custom_answer_text';
        data = {customAnswerText: self.evaluationObject.analystAnswerText};
      } else {
        url = '/evaluations/' + self.evaluationObject.id + '/analyst_answer_text';
        data = {analystAnswerText: self.evaluationObject.analystAnswerText};
      }
      Api.send('PATCH', url, data)
      .then((response) => {
        self.$root.notifyy('success', response.msg);
        if (self.evaluationObject.isCustom) {
          self.fetchCustomQuestions();
        } else {
          self.fetchQuestions();
        }
      })
      .catch((err) => {
        self.$root.notifyy('danger', err.msg);
      });
    },

    saveEvaluationAnalystNotes() {
      let self = this;
      if (!self.evaluationObject.id) {
        return false;
      }
      self.evaluationObject.analystNotes = self.evaluationObject.analystNotes.replace(/<p>(<br>|\s+)<\/p>/g, '');
      let url = '';
      let data = {};
      if (self.evaluationObject.isCustom) {
        url = '/custom_evaluations/' + self.evaluationObject.id + '/custom_notes';
        data = {customNotes: self.evaluationObject.analystNotes};
      } else {
        url = '/evaluations/' + self.evaluationObject.id + '/analyst_notes';
        data = {analystNotes: self.evaluationObject.analystNotes};
      }
      Api.send('PATCH', url, data)
      .then((response) => {
        self.$root.notifyy('success', response.msg);
      })
      .catch((err) => {
        self.$root.notifyy('danger', err.msg);
      });
    },

    saveEvaluationSource() {
      let self = this;
      if (!self.evaluationObject.id) {
        return false;
      }
      self.evaluationObject.source = self.evaluationObject.source.replace(/<p>(<br>|\s+)<\/p>/g, '');
      let url = '';
      let data = {};
      if (self.evaluationObject.isCustom) {
        url = '/custom_evaluations/' + self.evaluationObject.id + '/custom_source';
        data = {customSource: self.evaluationObject.source};
      } else {
        url = '/evaluations/' + self.evaluationObject.id + '/source';
        data = {source: self.evaluationObject.source};
      }
      Api.send('PATCH', url, data)
      .then((response) => {
        self.$root.notifyy('success', response.msg);
      })
      .catch((err) => {
        self.$root.notifyy('danger', err.msg);
      });
    },

    saveEvaluationAnalystAnswerNumeric() {
      let self = this;
      if (!self.evaluationObject.id) {
        return false;
      }
      let url = '';
      let data = {};
      if (self.evaluationObject.isCustom) {
        url = '/custom_evaluations/' + self.evaluationObject.id + '/custom_answer_numeric';
        data = {customAnswerNumeric: self.withoutThousandsSeparator(self.evaluationObject.analystAnswerNumeric), isEducatedGuess: self.evaluationObject.metaDto.isEducatedGuess};
      } else {
        url = '/evaluations/' + self.evaluationObject.id + '/analyst_answer_numeric';
        data = {analystAnswerNumeric: self.withoutThousandsSeparator(self.evaluationObject.analystAnswerNumeric), isEducatedGuess: self.evaluationObject.metaDto.isEducatedGuess};
      }
      Api.send('PATCH', url, data)
      .then((response) => {
        self.$root.notifyy('success', response.msg);
        if (self.evaluationObject.isCustom) {
          self.fetchCustomQuestions();
        } else {
          self.fetchQuestions();
        }
      })
      .catch((err) => {
        self.$root.notifyy('danger', err.msg);
      });
    },

    deleteEvaluation () {
      let self = this;
      if (!self.evaluationObject.id) {
        return false;
      }
      self.deletingEvaluation = true;
      const url = (self.evaluationObject.isCustom) ? '/custom_evaluations/' + self.evaluationObject.id : '/evaluations/' + self.evaluationObject.id;
      Api.send('DELETE', url, {})
      .then((response) => {
        if (self.evaluationObject.isCustom) {
          self.fetchCustomQuestions();
        } else {
          self.fetchQuestions();
        }
        self.showDeleteEvaluationModal = false;
        self.$modal.hide('evaluation-modal');
        self.$root.notifyy('success', response.msg);
        this.resetEvaluationObject();
      })
      .catch((err) => {
        self.$root.notifyy('danger', err.msg);
      })
      .finally(() => {
        self.deletingEvaluation = false;
      });
    },

    deleteCustomQuestion () {
      let self = this;
      if (!self.customQuestionObject.id) {
        return false;
      }
      self.deletingCustomQuestion = true;
      const url = '/custom_questions/' + self.customQuestionObject.id;
      Api.send('DELETE', url, {})
      .then((response) => {
        self.fetchCustomQuestions();
        self.$modal.hide('delete-custom-question-modal');
        self.$root.notifyy('success', response.msg);
      })
      .catch((err) => {
        self.$root.notifyy('danger', err.msg);
      })
      .finally(() => {
        self.deletingCustomQuestion = false;
      });
    },

    addCustomQuestion () {
      let self = this;
      if (!self.customCriterionToAdd) {
        return false;
      }
      self.addingCustomQuestion = true;
      const url = '/cases/' + self.casee.id + '/custom_questions';
      Api.send('POST', url, {order: self.customCriterionToAdd.order, customCriterionId: self.customCriterionToAdd.id})
      .then((response) => {
        self.fetchCustomQuestions();
        self.$root.notifyy('success', response.msg);
      })
      .catch((err) => {
        self.$root.notifyy('danger', err.msg);
      })
      .finally(() => {
        self.addingCustomQuestion = false;
      });
    },

    fetchCustomCriteriaByTopic() {
      let self = this;
      if (!self.selectedCustomTopic) {
        return false;
      }
      Api.send('GET', '/custom_topics/' + self.selectedCustomTopic + '/custom_criteria', {})
      .then((response) => {
        self.customCriteriaByTopic = response;
      })
      .catch((err) => {
        
      });
    },

    initAddCustomQuestionModal() {
      this.customCriterionToAdd = null;
      this.fetchCustomCriteriaByTopic();
      this.$modal.show('add-custom-question-modal');
    },

    exportAsExcel() {
      let loggedUser = this.$root.getLoggedUser();
      location.replace(Api.getBaseUrl() + '/cases/' + this.questionObject.caseId + '/export_excel?bearer_token=' + loggedUser.token);
    },

    stripHtml(html) {
      if (!html || html === '') {
        return '';
      }
      let temporalDivElement = document.createElement("div");
      temporalDivElement.innerHTML = html;
      return temporalDivElement.textContent;
    },

    withThousandsSeparator(number) {
      if (number === null || number === '') {
        return null;
      }
      return number.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ',');
    },

    withoutThousandsSeparator(number) {
      if (number === null || number === '') {
        return null;
      }
      return parseFloat(number.replace(/,/g, ''));
    },

    saveCaseIsPublic() {
      let self = this;
      if (!self.casee.id) {
        return false;
      }
      self.savingCasePublic = true;
      Api.send('PATCH', '/cases/' + self.casee.id + '/is_public', {isPublic: self.casee.isPublic})
      .then((response) => {
        self.$root.notifyy('success', response.msg);
      })
      .catch((err) => {
        self.$root.notifyy('danger', err.msg);
      })
      .finally(() => {
        self.savingCasePublic = false;
      });
    },

    handleTreeItemClicked(object) {
      if (!object.item) {
        return false;
      }
      let item = object.item;
      let isCustom = object.isCustom;
      if (!item.id) {
        return false;
      }
      let all = document.querySelectorAll('.topic-item.active');
      for (let i = 0; i < all.length; i++) {
        all[i].className = 'topic-item';
      }
      if (isCustom) {
        document.getElementById('custom-topic-item-' + item.id).className = 'topic-item active';
        this.selectedTopic = null;
        this.selectedCustomTopic = item.id;
      } else {
        document.getElementById('topic-item-' + item.id).className = 'topic-item active';
        this.selectedTopic = item.id;
        this.selectedCustomTopic = null;
        this.filterQuestions();
      }
    },

    filterQuestions() {
      this.filteredOutQuestions = [];
      if (this.searchQuestionsQuery === '') {
        return false;
      }
      if (this.selectedTopic) {
        for (let i in this.topicsFlat[this.selectedTopic].questionDtos) {
          let q = this.topicsFlat[this.selectedTopic].questionDtos[i];
          if (q.title.search(new RegExp(this.searchQuestionsQuery, 'i')) === -1) {
            this.filteredOutQuestions.push(q.id);
          }
        }
      }
      if (this.selectedCustomTopic) {
        for (let i in this.customTopicsFlat[this.selectedCustomTopic].questionDtos) {
          let q = this.customTopicsFlat[this.selectedCustomTopic].questionDtos[i];
          if (q.title.search(new RegExp(this.searchQuestionsQuery, 'i')) === -1) {
            this.filteredOutQuestions.push(q.id);
          }
        }
      }
    },

    formatNumber(number) {
      if (number > 1000000000000) {
        return (number/1000000000000).toFixed(2) + 'T'
      }

      if (number > 1000000000) {
        return (number/1000000000).toFixed(2) + 'B'
      }

      if (number > 1000000) {
        return (number/1000000).toFixed(2) + 'M'
      }

      if (number > 1000) {
        return (number/1000).toFixed(2) + 'K'
      }

      return number;
    },

    handleCaseYearChanged() {
      this.$router.push({path:'/case/' + this.selectedCaseId});
      location.reload(true);
    },

    numericToBooleanAnswer: function(number) {
      if (number == 1) {
        return 'Yes';
      }
      if (number == 0) {
        return 'No';
      }
      if (number == 0.5) {
        return 'Partially';
      }
      return number;
    },

    handleFrameworkChanged: function() {
      this.selectedTopic = null;
      this.selectedCustomTopic = null;
      if (this.selectedFramework === 'gri2021') {
        this.selectedPillar = 'gri';
      } else if (['vsme_basic', 'vsme_comprehensive'].indexOf(this.selectedFramework) > -1) {
        this.selectedPillar = 'general';
      } else {
        this.selectedPillar = 'environmental';
      }

      this.fetchTopicsTree();
    },

    showPillarFilter: function(pillr) {
      if (pillr === 'gri') {
        if (this.selectedFramework === 'gri2021') {
          return true;
        }
      } else {
        if (this.selectedFramework !== 'gri2021') {
          return true;
        }
      }
      return false;
    }

  },
};
</script>
<style scoped>
.questions_tree {
  padding-left: 0;
  line-height: 2em;
  list-style-type: none;
  font-size: 1.2em;
  max-height: 400px;
  overflow-y: auto;
}
.pillar-filter {
  font-size: 22px;
  list-style: square;
}
.pillar-filter .active {
  text-decoration: underline;
  font-weight: bold;
}
.question-card {
  position: relative;
}
.question-edit {
  position: absolute;
  top: 5px;
  right: 5px;
  height: 22px;
  width: 22px;
  border: 1px solid #222222;
  border-radius: 50%;
  font-size: 18px;
  line-height: 22px;
  text-align: center;
}
.question-delete {
  position: absolute;
  top: 30px;
  right: 5px;
  height: 22px;
  width: 22px;
  border: 1px solid #cf1c1c;
  border-radius: 50%;
  font-size: 22px;
  line-height: 22px;
  text-align: center;
  color: #cf1c1c;
}
.pointer {
  cursor: pointer;
}
.question-answer-text {
  font-size: 80%;
}
p {
  font-size: 80%;
}
.question-answer-text p {
  font-size: 80% !important;
}
.bg-gri {
  background-color: rgb(0 123 211 / 13%);
}
.bg-environmental {
  background-color: rgb(45 206 137 / 13%);
}
.bg-social {
  background-color: rgb(255 214 0 / 13%);
}
.bg-governance {
  background-color: rgb(94 114 228 / 13%);
}
.bg-financial {
  background-color: rgb(255, 231, 221);
}
.bg-general {
  background-color: rgb(245, 246, 250);
}
.clear {
  clear: both;
}
.ti-info {
  border-radius: 50%;
  border: 1px solid #222222;
}
.card hr {
  border-color: #a1a1a1;
}
.cursor-forbidden {
  cursor: not-allowed;
}
</style>